/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} L7_How_H2Inputs */

const es_l7_how_h2 = /** @type {(inputs: L7_How_H2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`De todo lo demás nos ocupamos nosotros.`)
};

const gl_l7_how_h2 = /** @type {(inputs: L7_How_H2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`De todo o demais encargámonos nós.`)
};

const en_l7_how_h2 = /** @type {(inputs: L7_How_H2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`We take care of everything else.`)
};

/**
* | output |
* | --- |
* | "We take care of everything else." |
*
* @param {L7_How_H2Inputs} inputs
* @param {{ locale?: "es" | "gl" | "en" }} options
* @returns {LocalizedString}
*/
export const l7_how_h2 = /** @type {((inputs?: L7_How_H2Inputs, options?: { locale?: "es" | "gl" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<L7_How_H2Inputs, { locale?: "es" | "gl" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "gl") return gl_l7_how_h2(inputs)
	if (locale === "en") return en_l7_how_h2(inputs)
	return es_l7_how_h2(inputs)
});